import { render, staticRenderFns } from "./place-info.vue?vue&type=template&id=a85cf28c&scoped=true&lang=pug"
import script from "./place-info.vue?vue&type=script&lang=js"
export * from "./place-info.vue?vue&type=script&lang=js"
import style0 from "./place-info.vue?vue&type=style&index=0&id=a85cf28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85cf28c",
  null
  
)

export default component.exports